<app-smash-back-btn (goBack)="back()"></app-smash-back-btn>

<div class="premium-card" *ngIf="!!(memberDetails$ | async)">
    <div class="premium-card-header">
        <div class="premium-card-header-title">
            <h1 translate>PREMIUM_TEAM_MEMBER_DETAILS_PROFILE_TITLE_SECTION</h1>
        </div>
        <div class="premium-card-header-actions">
            <button class="btn-new red-light" *ngIf="(memberDetails$ | async) && (!(memberDetails$ | async)?.provisioned || (memberDetails$ | async).status === 'Disabled') && (memberDetails$ | async)?.id !== (activeIdentity$ | async)?.id"
                (click)="openModalDeleteMember()" translate>PREMIUM_TEAM_MEMBER_DETAILS_BUTTON_LABEL_DELETE_MEMBER</button>
        </div>
    </div>
    <div class="premium-card-center">
        <ng-container *ngIf="(memberEditionPending$ | async) || (memberDetailsLoading$ | async); else notPending">
            <div class="loading">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #notPending>
            <form class="premium-form-content-inline" [formGroup]="memberDetailsForm" [appConnectForm]="memberDetails$ | async">
                <div class="premium-form-section">
                    <div class="premium-form-section-title">
                        <div class="label">{{'PREMIUM_TEAM_MEMBER_DETAILS_FORM_PLACEHOLDER_FIRSTNAME' | translate }}</div>
                    </div>
                    <div class="premium-form-section-content">
                        <app-smash-input type="text" borderStyle="full" formControlName="firstName" [error]="f.firstName.dirty && f.firstName.errors"
                            [disabled]="(memberDetails$ | async).provisioned">
                        </app-smash-input>
                    </div>
                </div>
                <div class="premium-form-section">
                    <div class="premium-form-section-title">
                        <div class="label">{{'PREMIUM_TEAM_MEMBER_DETAILS_FORM_PLACEHOLDER_LASTNAME' | translate }}</div>
                    </div>
                    <div class="premium-form-section-content">
                        <app-smash-input type="text" borderStyle="full" formControlName="lastName" [error]="f.lastName.dirty && f.lastName.errors"
                            [disabled]="(memberDetails$ | async).provisioned">
                        </app-smash-input>
                    </div>
                </div>
                <div class="premium-form-section">
                    <div class="premium-form-section-title">
                        <div class="label">{{'PREMIUM_TEAM_MEMBER_DETAILS_FORM_PLACEHOLDER_EMAIL' | translate }}</div>
                    </div>
                    <div class="premium-form-section-content">
                        <app-smash-input type="text" borderStyle="full" formControlName="username" [error]="f.username.dirty && f.username.errors"
                            [disabled]="(memberDetails$ | async).provisioned">
                        </app-smash-input>
                    </div>
                </div>
            </form>
        </ng-template>
    </div>
    <div class="premium-card-footer">
        <div class="error-message-container error-message">{{ ( memberEditionError$ | async )?.error }}</div>
        <div class="premium-card-footer-buttons-container">
            <button type="submit" class="btn-new red member-buttons" [disabled]="!memberDetailsForm.dirty || (memberDetails$ | async).provisioned"
                (click)="updateMemberInformations()">{{ 'PREMIUM_TEAM_MEMBER_DETAILS_FORM_BUTTON_LABEL_SAVE' | translate }}</button>
        </div>
    </div>
</div>

<div class="premium-card">
    <div class="premium-card-header">
        <div class="premium-card-header-title">
            <h1 translate>PREMIUM_TEAM_MEMBER_DETAILS_ROLES_TITLE_SECTION</h1>
            <h2 translate [translateParams]="{'username': (memberDetails$ | async)?.username}">PREMIUM_TEAM_MEMBER_DETAILS_ROLES_DESCRIPTION</h2>
        </div>
        <div class="premium-card-header-actions">
            <div class="icon icon-refresh" (click)="refreshRoles()">
                <i class="icon-smash_remote"></i>
            </div>
            <!-- FIX ME RE-ENABLE ME WHEN PAGINATION AND/OR DYNAMIC USER SEARCH IS IMPLEMENTED -->
            <button [disabled]="!(memberAttributableRoles$ |async)?.length" class="btn-new red" *ngIf="!(memberDetails$ | async)?.provisioned" (click)="openModalAttachRoleToMember()">
                {{ 'PREMIUM_TEAM_MEMBER_DETAILS_ROLES_BUTTON_LABEL_ATTACH_ROLE_TO_MEMBER' | translate }}
            </button>
        </div>
    </div>
    <ng-container *ngIf="(memberRolesLoading$ | async); else memberRolesNotLoading">
        <div class="premium-card-loading-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </ng-container>
    <ng-template #memberRolesNotLoading>
        <div class="premium-card-center">
            <ng-container *ngIf="(memberRolesLoaded$ | async); else memberRolesNotLoaded">
                <ng-container *ngIf="(memberRoles$ | async)?.length > 0; else noRoles">
                    <app-smash-data-table [data]="(memberRoles$ | async)" [searchValue]="search"
                        [columns]='roleListColumnsEnabled' [enableMoreOptions]='!(memberDetails$ | async)?.provisioned'
                        [enableColumnOptions]='false' rowClickable='false' [paginationEnabled]="true">
                        <ng-template #optionsList let-item>
                            <li (click)="openModalDetachRoleFromMember(item)">
                                <a>
                                    {{ 'PREMIUM_TEAM_MEMBER_DETAILS_ROLES_BUTTON_LABEL_DETACH_ROLE_FROM_MEMBER' | translate }}
                                </a>
                            </li>
                        </ng-template>
                    </app-smash-data-table>
                </ng-container>
                <ng-template #noRoles>
                    <div class="premium-card-center-no-content">
                        <div class="premium-card-center-no-content-message">
                            {{ 'PREMIUM_TEAM_MEMBER_DETAILS_ROLES_TABLE_NO_ROLES' | translate }}
                        </div>
                    </div>
                </ng-template>
            </ng-container>
            <ng-template #memberRolesNotLoaded>
                <!-- TO DO Error Message -->
            </ng-template>
        </div>
    </ng-template>
</div>

<div class="premium-card">
    <div class="premium-card-header">
        <div class="premium-card-header-title" *ngIf="(memberDetails$ | async)?.username">
            <h1 translate>PREMIUM_TEAM_MEMBER_DETAILS_TABLE_MEMBER_GROUPS_TITLE</h1>
            <h2 translate [translateParams]='{email: (memberDetails$ | async).username}'>PREMIUM_TEAM_MEMBER_DETAILS_TABLE_MEMBER_GROUPS_SUBTITLE
            </h2>
        </div>
        <div class="premium-card-header-actions" *ngIf="(memberGroups$ | async)">
            <button class="btn-new red" *ngIf="!(memberDetails$ | async)?.provisioned" (click)="openModalAttachNewGroup()"
                translate>PREMIUM_TEAM_MEMBER_DETAILS_TABLE_MEMBER_GROUPS_BUTTON_LABEL_ADD_GROUP</button>
        </div>
    </div>
    <ng-container *ngIf="(memberGroupsLoading$ | async); else memberGroupsLoaded">
        <div class="premium-card-loading-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </ng-container>
    <ng-template #memberGroupsLoaded>
        <ng-container *ngIf="(memberGroups$ | async)?.length > 0; else noGroupsAttachedToUser">
            <div class="premium-card-center">
                <app-smash-data-table [data]="(memberGroups$ | async)" [columns]='groupColumnsEnabled' rowClickable='true'
                    (rowClicked)="goToGroupDetails($event.id)" [enableMoreOptions]='false' [enableMoreOptionsPredicate]='isGroupDetachable'>
                    <!-- <ng-template #optionsList let-item>
                        <li (click)="openModalDetachUserFromGroup(item)" translate>
                            PREMIUM_TEAM_MEMBER_DETAILS_TABLE_MEMBER_GROUPS_BUTTON_LABEL_DETACH_GROUP</li>
                    </ng-template> -->
                </app-smash-data-table>
            </div>
        </ng-container>
        <ng-template #noGroupsAttachedToUser>
            <div class="premium-card-center-no-content">
                <h1 class="premium-card-no-content-message" translate [translateParams]='{email: (memberDetails$ | async)?.username}'>
                    PREMIUM_TEAM_MEMBER_DETAILS_TABLE_MEMBER_GROUPS_NO_GROUPS_ATTACHED</h1>
            </div>
        </ng-template>
    </ng-template>
</div>

<div class="premium-card">
    <div class="premium-card-header">
        <div class="premium-card-header-title">
            <h1>
                {{ 'PREMIUM_TEAM_MEMBER_DETAILS_DATA_USE' | translate }}
            </h1>
        </div>
    </div>
    <div class="premium-card-center">
        <div class="chart-section">
            <div class="chart-parameters-container">
                <div class="chart-parameters-container-left">
                    <ng-select class="select-period" [items]="PERIODS" bindLabel="name" (change)="selectPeriod($event)" [clearable]="false"
                        [searchable]="false" [(ngModel)]="selectedPeriod">
                        <ng-template ng-label-tmp let-item="item">
                            {{item.name | translate}}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                            {{item.name | translate}}
                        </ng-template>
                    </ng-select>
                </div>
                <div class="chart-parameters-container-right">
                    <ng-select class="select-unit" [items]="selectedPeriod.units" bindLabel="name" (change)="selectUnit($event)" [clearable]="false"
                        [searchable]="false" [(ngModel)]="selectedUnit">
                        <ng-template ng-label-tmp let-item="item">
                            {{item.name | translate}}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                            {{item.name | translate}}
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="charts-wrapper">
                <div class="chart-container">
                    <app-smash-chart type="line" lineColor="#EA5159" [chartTitle]="transferCountsChartTitle"
                        [data]="memberTransferCountSeries$ | async" xAxisKey='date' yAxisKey='value'>
                    </app-smash-chart>
                </div>
                <div class="chart-container">
                    <app-smash-chart type="line" lineColor="#EA5159" [chartTitle]="fileCountsChartTitle" [data]="memberFileCountSeries$ | async"
                        xAxisKey='date' yAxisKey='value'></app-smash-chart>
                </div>
                <div class="chart-container">
                    <app-smash-chart type="line" lineColor="#EA5159" [chartTitle]="transferSizeUploadedChartTitle"
                        [data]="memberSizeCountSeries$ | async" yAxisType='byte' xAxisKey='date' yAxisKey='value'></app-smash-chart>
                </div>
            </div>
        </div>
    </div>
</div>